import { startCase } from 'lodash';
import React from 'react';

import { env } from '~/commons/config';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

const FieldPayments = ({ order, values, disabled }) => {
  const reason = order?.taxExempt?.reason;

  return (
    <>
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">Discount</h6>
      <div className="row">
        <div className="col">
          <FormGroup label="Percent Discount" name="discount.percent" type="number" appendLabel="%" disabled={disabled} />
        </div>
        <div className="col">
          <FormGroup label="Fixed Discount" name="discount.fixed" type="number" disabled={disabled} />
        </div>
      </div>
      <div className="row">
        <div className="col">
          {/* <FormGroup label="Total Discount" name="discount.total" type="number" disabled /> */}
          <div className="form-group">
            <label htmlFor="taxation.total">Total Discount</label>
            <div className="input-group ">
              <input className="input-group-text form-control" style={{ textAlign: 'left' }} value={values?.discount?.total ?? 0} name="discount.total" disabled />
            </div>
          </div>
        </div>
      </div>
      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">Taxation</h6>
      <div className="row">
        <div className="col">
          {/* <FormGroup label="Calculated taxation" name="taxation.calculated" disabled /> */}
          <div className="form-group">
            <label htmlFor="taxation.calculated">Calculated taxation</label>
            <input className="input-group-text form-control" style={{ textAlign: 'left' }} value={values?.taxation?.calculated ?? 0} name="taxation.calculated" disabled />
          </div>
        </div>
        <div className="col">
          <FormGroup label="Input taxation" name="taxation.input" type="number" disabled={disabled} />
        </div>
        <div className="col">
          <FormGroup label="Input taxation percent" name="taxation.percent" type="number" appendLabel="%" disabled={disabled} />
        </div>
      </div>
      <div className="row">
        <div className="col">
          {/* <FormGroup label="Final taxation" type="number" name="taxation.total" disabled /> */}
          <div className="form-group">
            <label htmlFor="taxation.total">Final taxation</label>
            <input className="input-group-text form-control" style={{ textAlign: 'left' }} value={values?.taxation?.total ?? 0} name="taxation.total" disabled />
          </div>
        </div>
      </div>

      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">Taxation Exempt</h6>
      <div className="row">
        <div className="col-2">
          <div className="form-group">
            <label>Active</label>
            <FormCheckGroup name="taxExempt.active" type="checkbox" label="" asSwitch disabled={disabled} />
          </div>
        </div>
        <div className="col">
          <FormGroup name="taxExempt.reason" as="select" disabled={disabled}>
            <option value=""> - </option>
            {reason && !env?.taxExempt.includes(reason) && <option value={reason}>{reason}</option>}
            {(env?.taxExempt || []).map((x) => (
              <option key={x} value={x}>
                {x}
              </option>
            ))}
          </FormGroup>
        </div>
        <div className="col-6">
          <FormGroup name="taxExempt.number" disabled={disabled} />
        </div>
      </div>

      <h6 className="small border-bottom text-muted py-1 pt-4 mb-3"></h6>
      <div className="row">
        <div className="col">
          {/* <FormGroup name="subtotal" type="number" disabled /> */}
          <div className="form-group">
            <label htmlFor="subtotal">Subtotal</label>
            <input className="input-group-text form-control" style={{ textAlign: 'left' }} value={values?.subtotal ?? 0} name="subtotal" disabled />
          </div>
        </div>
        <div className="col">
          <FormGroup name="currency" as="select" disabled={disabled}>
            <option value=""> - </option>
            {env.currencies.map(({ code, symbol }) => (
              <option value={code} key={code}>
                {`${startCase(code)} - ${symbol}`}
              </option>
            ))}
          </FormGroup>
        </div>
        <div className="col-auto align-self-center">
          {order?.isTradePrice ? 'Trade Price' : 'Retail Price'}
        </div>
      </div>
      <div className="row">
        <div className="col">
          {/* <FormGroup name="total" type="number" disabled /> */}
          <div className="form-group">
            <label htmlFor="total">Total</label>
            <input className="input-group-text form-control" style={{ textAlign: 'left' }} value={values?.total ?? 0} name="total" disabled />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormGroup label="Payment Reference" name="paymentRefNo" disabled={disabled} />
        </div>
      </div>
    </>
  );
};

export default FieldPayments;
